import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import V2AnnouncementBar from "@/components/V2AnnouncementBar";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Layout() {
  const { pathname } = useLocation();
  const { lang } = useLanguage();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Phase 24: SAS V2 launch signal — mounted above Navbar so it
          appears on every public route and both language trees. */}
      <V2AnnouncementBar />
      <Navbar />
      <main className="flex-1">
        {/* P1 stability: a page-level crash renders an inline fallback
            here while the announcement bar, navbar and footer stay
            usable. `resetKey={pathname}` clears the error on navigation. */}
        <ErrorBoundary scope="section" resetKey={pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
      <Footer />
      {/* Site-wide toast layer (Sonner). Used by SaveButton and other
          interactive surfaces. Mirrors the active language so the
          dismiss/undo/action buttons render in the right direction. */}
      <Toaster
        position={lang === "ar" ? "bottom-left" : "bottom-right"}
        dir={lang === "ar" ? "rtl" : "ltr"}
        richColors={false}
        closeButton
        toastOptions={{
          // Inherit the site typography (IBM Plex Sans Arabic / Inter) instead
          // of Sonner's built-in system font stack, so Arabic shapes correctly.
          style: { fontFamily: "inherit" },
        }}
      />
    </div>
  );
}
